import corepattern from './core-pattern'
import coredensity from './core-density'

export default {
  'core-pattern': corepattern,
  'core-density': coredensity
}